// extracted by mini-css-extract-plugin
export var batch = "basket-module--batch--78db8";
export var container = "basket-module--container--0554b";
export var icon = "basket-module--icon--f171c";
export var text = "basket-module--text--b1268";